import React, { Component } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import NotFound from "../../Pages/NotFound/NotFound";
import { NavLink, Routes, Route } from "react-router-dom";
import Home from "../../Pages/Home/Home";
import About from "../../Pages/About/About";
import Services from "../../Pages/Services/Services";
import Careers from "../../Pages/Careers/Careers";
import CareerDetails from "../../Pages/CareerDetails/CareerDetails";
import Portfolio from "../../Pages/Portfolio/Portfolio";
import ProjectView from "../../Pages/ProjectView/ProjectView";
import ContactUs from "../../Pages/ContactUs/contactUs";
import SoftwareAndMobile from "../../Pages/Services/Sub-Services/Software&Mobile/softwareAndMobile";
import SubServices from "../../Pages/Services/Sub-Services/SubServices/subServices";
import ThankYouContactUs from "../../Pages/ThankYou-ContactUS/ThankYouContactUs";
import Terms from "../../Pages/TermsAndCondition/terms";
import Privacy from "../../Pages/PrivacyPolicy/privacy";
import './NavBar.css';

export default class NavBar extends Component {
  render() {
    return (
      <>
        <Navbar expand="lg" className="nav-bar px-4">
            <Navbar.Brand as={NavLink} to="/" className="fw-bold">
              <img src="./assets/images/ambrum-logo.png" alt="" />
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="main-navbar-nav" />
            <Navbar.Collapse id="main-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link as={NavLink} to="/" end>
                  Home
                </Nav.Link>
                <Nav.Link as={NavLink} to="/about" end>
                  About
                </Nav.Link>
                <Nav.Link as={NavLink} to="/services" end>
                  Services
                </Nav.Link>
                <Nav.Link as={NavLink} to="/portfolio" end>
                  Portfolio
                </Nav.Link>
                <Nav.Link as={NavLink} to="/careers" end>
                  Careers
                </Nav.Link>
                {/* <Nav.Link as={NavLink} to="/blog" end>
                  Blog
                </Nav.Link> */}
                <Nav.Link as={NavLink} to="/talk-to-Us" end>
                  Talk to Us
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
        </Navbar>
        <div>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/software-mobile" element={<SoftwareAndMobile />} />
            <Route path="/services/sub-services" element={<SubServices />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/career-details" element={<CareerDetails />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/project-view" element={<ProjectView />} />
            <Route path="/talk-to-us" element={<ContactUs />} />
            <Route path="/thankyou" element={<ThankYouContactUs />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/privacy-policy" element={<Privacy />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </>
    );
  }
}
